<template>
  <li :class="{'nav-item': true, opened: visible}">
    <a href="#" @click.prevent="collapse()" :aria-expanded="visible" class="nav-link">
      <i :class="`${icon} fa-xs`" style="color: #9ea4aa"></i>
      <span class="nav-link-text">{{ name }} 
        <b :class="{ caret: true, opened: visible }">
          <i class="ti-angle-down"></i>
        </b>
      </span>
    </a>
    <b-collapse v-model="visible">
      <ul class="nav">
        <slot></slot>
      </ul>
    </b-collapse>
  </li>
</template>

<script>
  export default {
    name: 'SidebarDropdown',
    props: {
      name: {
        type: String,
      },
      icon: {
        type: String,
      },
      color: {
        type: String,
        default: 'default',
      },
    },
    data(){
      return {
        visible: false,
      }
    },
    methods: {
      collapse(){
        if (this.visible == false) {
          this.$parent.$children.forEach(child => {
            if (child !== this && child.visible) {
              child.visible = false;
            }
          });
        }
        this.visible = !this.visible;
        if( this.visible ) {
          this.$emit('opened');
        }
      }
    }
  }
</script>


<style scoped>
  .nav-item a span {
    color: #fff;
    font-weight: 400; 
    font-size: 15.4px
  }

  .nav-link a i {
    color: #fff !important; 
    font-size: 20px !important;
    line-height: 0 !important;
    top: auto
  }

  li.opened {
    padding-bottom: 10px;
  }
</style>